<rx-tip class="mb20 flex-nosize" [id]="tipType.adminUpload">
  <span>All forms must have defined signature types, please watch the&nbsp;</span>
  <a>RxPhoto Forms Upload Tutorial</a><span> to learn more </span>
</rx-tip>

<div class="list">
  <span>
    <rx-icon name="icon-check" class="mr20 mb10"></rx-icon>
    Our team will convert your forms.
  </span>
  <span>
    <rx-icon name="icon-check" class="mr20 mb10"></rx-icon>
    Your forms will be ready in 7 to 10 days.
  </span>
  <span>
    <rx-icon name="icon-check" class="mr20 mb20"></rx-icon>
    Your forms will be optimized for usability and comprehension.
  </span>
  <span class="mb20">
    Price:
    <a class="ml20"> You will be invoiced $20 per page.</a>
  </span>
</div>

<div class="drag-item mb20" (drop)="onDrop($event)" (dragover)="onDragOver($event)">
  <span>Drag your forms here or select file from your computer.</span>
  <span>
    <rx-button icon="icon-upload" class="icon-white" (click)="onActive()">Upload Form</rx-button>
    <input #input class="none" type="file" (change)="onChange($event)" multiple />
  </span>
  <span>Supported file formats <a>PDF, PNG, JPG, DOC, DOCX</a> up to 10 megabytes.</span>
</div>

<div
  class="upload-list"
  *ngFor="let file of getFiles() | async; let i = index; trackBy: trackByFn; let last = last"
  [ngClass]="{ bbn: last }"
>
  <rx-icon name="icon-cross-circle" class="mr20" (click)="removeFile(i)"></rx-icon>
  {{ file.name }}
</div>

<div class="list">
  <span>
    <mat-checkbox> I understand that I will be invoiced $20 per page of each form. </mat-checkbox>
  </span>
  <span>
    <mat-checkbox>
      I understand that I watched the forms upload tutorial and defined all signature types.
    </mat-checkbox>
  </span>
  <span>
    <mat-checkbox> I confirm that I read the <a>Tearms of Service</a> regarding RxPhoto forms. </mat-checkbox>
  </span>
</div>
